<template>
  <div>
    <section class="section is-main-section">
      <card-component title="User Form" icon="account" has-back>
        <form @submit.prevent="onSubmit">
          <b-field
            :message="$v.username.msg"
            :type="$v.username.status"
            horizontal
            label="User"
          >
            <b-input placeholder="Username" v-model="form.username" />
          </b-field>
          <b-field :message="$v.email.msg" :type="$v.email.status" horizontal>
            <b-input placeholder="Email" type="email" v-model="form.email" />
          </b-field>
          <hr />
          <b-field
            :message="$v.password.msg"
            :type="$v.password.status"
            horizontal
            label="Password"
          >
            <b-input
              placeholder="Password"
              type="password"
              v-model="form.password"
            />
          </b-field>
          <b-field
            horizontal
            :message="$v.conf_password.msg"
            :type="$v.conf_password.status"
          >
            <b-input
              placeholder="Confirm Password"
              type="password"
              v-model="form.conf_password"
            />
          </b-field>
          <hr />
          <b-field label="Role" horizontal>
            <b-select placeholder="Select role" v-model="form.role_id">
              <option v-for="role in roles" :value="role.id" :key="role.id">
                {{ role.name }}
              </option>
            </b-select>
          </b-field>
          <hr />
          <b-field
            v-if="hasGatewayUserPermission && gateways"
            custom-class="is-normal"
            label="Gateways"
            horizontal
          >
            <multiselect
              v-model="form.gateways"
              :options="gateways"
              multiple
              label="name"
              track-by="name"
            />
          </b-field>
          <hr />
          <div ref="submit">
            <b-field horizontal>
              <b-button
                :loading="isLoading"
                native-type="submit"
                type="is-primary"
              >
                Submit
              </b-button>
            </b-field>
          </div>
        </form>
      </card-component>
    </section>
  </div>
</template>

<script>
import { create as createUser } from '@/api/user'
import { read as readGateway } from '@/api/gateway'
import { read as readRole } from '@/api/role'

import { required, minLength, sameAs } from '@/utils/validation'

import formMixin from '@/mixins/form'
import validationMixin from '@/mixins/validation'

import Multiselect from 'vue-multiselect'

export default {
  name: 'CreateUser',
  components: { Multiselect },
  mixins: [formMixin, validationMixin],
  data() {
    return {
      clients: [],
      gateways: [],
      roles: [],
      rules: {
        username: [required, minLength(5)],
        email: [required],
        password: [required],
        conf_password: [required, sameAs(this, 'password')],
        role_id: [required]
      },
      form: {
        username: null,
        email: null,
        password: null,
        conf_password: null,
        gateways: [],
        role_id: null,
        client_id: null
      }
    }
  },
  created() {
    readGateway()
      .then(res => {
        this.gateways = res.data.gateways
      })
    readRole()
      .then(res => {
        this.roles = res.data.roles
      })
  },
  computed: {
    isSuperAdmin() {
      return this.$store.getters['auth/isSuperAdmin']
    },
    hasGatewayUserPermission() {
      return this.$store.getters['auth/hasPermission']('GATEWAY_USER', 'POST')
    }
  },
  methods: {
    submit() {
      if (!this.isSuperAdmin) {
        this.form.client_id = this.$store.state.auth.user.clientID
      }

      return createUser({
        ...this.form,
        gateway_ids: this.form.gateways.map(gateway => gateway.id)
      })
        .then(() => {
          this.$router.back()
        })
    }
  }
}
</script>
